import { Injectable, Optional } from '../components/dependency-injection/decorators';
import { Events } from '../components/event-manager/event/events';
import { NpiPostDetectEvent } from '../components/event-manager/event/npi-post-detect.event';
import { NpiPreDetectEvent } from '../components/event-manager/event/npi-pre-detect.event';
import { Logger } from '../components/logger/logger';
import { EventSubscriberInterface } from '../interfaces/components/event-manager/subscriber/event-subscriber.interface';

@Injectable()
export class NpiDetectionSubscriber implements EventSubscriberInterface {
  public constructor (@Optional() private readonly logger?: Logger) {
  }

  public getSubscribedEvents (): { [key in Events]?: string } {
    return {
      [ Events.NPI_PRE_DETECT ]: 'onPreDetect',
      [ Events.NPI_POST_DETECT ]: 'onPostDetect',
    };
  }

  public async onPreDetect (event: NpiPreDetectEvent): Promise<void> {
    this.logger?.debug(`Pre detect npi for source "${event.getSource().constructor.name}"`);
  }

  public async onPostDetect (event: NpiPostDetectEvent): Promise<void> {
    this.logger?.debug(
      `Post detect npi "${event.getNpi().getEncryptedNumber()}" and source "${event.getSource().constructor.name}"`,
    );
  }
}
